/* eslint-disable @typescript-eslint/no-empty-function */
(function (config) {
	'use strict';

	if (window.FS?.globalInfo?.qualtricsCookie) {
		config = {
			environment: window.FS.globalInfo.environmentName === 'live' ? '' : 'test',
			maxUrlLength: 2048,
			srcookie: window.FS.globalInfo.qualtricsCookie,
		};
	} else {
		config = JSON.parse(config);
	}
	let qualtricsApiLoaded = !!window.QSI?.API;
	let GDPRLoaded = false;
	let ranQueue = false;
	let performanceCookiesAllowed = false;
	let interceptPassedCalls = [];
	let sessionRecordingStartCalls = [];

	// function to pull cookie value
	function getOABCookie(name) {
		var value = '; ' + document.cookie;
		var parts = value.split('; ' + name + '=');
		if (parts.length == 2) return parts.pop().split(';').shift();
	}

	const runQueuedFunctions = () => {
		ranQueue = true;
		if (interceptPassedCalls.length > 0) {
			interceptPassedCalls.forEach(queuedFunction => {
				queuedFunction();
			});
			interceptPassedCalls = [];
		}
		if (sessionRecordingStartCalls.length > 0) {
			sessionRecordingStartCalls.forEach(queuedStartFunction => {
				queuedStartFunction();
			});
			sessionRecordingStartCalls = [];
		}
	};

	window.addEventListener(
		'qsi_js_loaded',
		() => {
			if (window.QSI?.API) {
				qualtricsApiLoaded = true;

				//Make sure w've had the opportunity to check performance cookies
				if (GDPRLoaded && !ranQueue) {
					runQueuedFunctions();
				}
			}
		},
		false
	);

	const runIntercept = (interceptId, shouldUnload) => {
		if (performanceCookiesAllowed) {
			//set the local storage so we know we did something to call this
			localStorage.setItem(`${interceptId}-ran`, true);
			if (shouldUnload) {
				window.QSI.API.unload();
			}
			window.QSI.API.load();
			window.QSI.API.run();
		} else {
			throw new Error('error running intercepts: Performance cookies must be enabled');
		}
	};

	const createSurveyLink = (surveyLink, interceptId, additionalEmbeddedData) => {
		let fullJourneyPhase = {};
		Object.keys(window.fullJourneyState || {}).map(key => {
			fullJourneyPhase[key] = window.fullJourneyState[key].journeyStage;
		});
		let allParams = {
			...additionalEmbeddedData,
			visitor_uuid: window.utag_data?.tealium_session_id,
			Intercept_Time_Spent_on_Site: window.QSI?.EmbeddedData?.getTimeOnSite(),
			Intercept_Search_Term: window.QSI?.EmbeddedData?.getSearchTerm(),
			Intercept_Site_Referrer: window.QSI?.EmbeddedData?.getSiteReferer(),
			Intercept_Page_Referrer: window.QSI?.EmbeddedData?.getReferer(),
			Intercept_Current_Page_URL: window.QSI?.EmbeddedData?.getCurrentPage(),
			Intercept_Total_Visited_Page_Count: window.QSI?.EmbeddedData?.getTotalPageCount(),
			Intercept_Unique_Visited_Page_Count: window.QSI?.EmbeddedData?.getPageCount(),
			Intercept_Recorded_Site_History: window.QSI?.EmbeddedData?.getHistory(),
			Intercept_Intercept_ID: interceptId,
			FullJourneyPhase: JSON.stringify(fullJourneyPhase),
			Environment: config.environment,
		};
		Object.keys(allParams).forEach(key => {
			if (!allParams[key]) {
				delete allParams[key];
			}
		});

		let paramsString = JSON.stringify(allParams);
		if (allParams.Intercept_Recorded_Site_History) {
			let maxLengthTotal = Math.floor(((config.maxUrlLength - surveyLink.length - 7 - 3) * 3) / 4);
			let maxLengthHistory =
				maxLengthTotal - (paramsString.length - allParams.Intercept_Recorded_Site_History.length);
			if (allParams.Intercept_Recorded_Site_History.length > maxLengthHistory) {
				let truncatedHistory = allParams.Intercept_Recorded_Site_History.substring(
					allParams.Intercept_Recorded_Site_History.length - maxLengthHistory
				);
				let firstDelimiter = truncatedHistory.match(/~\d+\|/);
				if (firstDelimiter) {
					allParams.Intercept_Recorded_Site_History = truncatedHistory.substring(
						firstDelimiter.index + firstDelimiter[0].length
					);
				}
			}
		}
		let encodedParams = btoa(JSON.stringify(allParams));
		return `${surveyLink}?Q_EED=${encodedParams.replace(/\+/g, '-')}`;
	};

	const hasInterceptPassed = async (interceptId, shouldUnload = true) => {
		if (qualtricsApiLoaded && GDPRLoaded) {
			if (performanceCookiesAllowed) {
				try {
					//clear out local storage for this id
					localStorage.removeItem(`${interceptId}-ran`);
					//Get the intercept
					const interceptAPI = await window.QSI.API.getIntercept(interceptId);
					const evaluationResult = interceptAPI.getEvaluationResult();
					return {
						passed: evaluationResult.passed,
						runIntercept: evaluationResult.passed
							? () => {
									return runIntercept(interceptId, shouldUnload);
								}
							: () => {},
						createSurveyLink: evaluationResult.passed
							? (surveyLink, additionalEmbeddedData) => {
									return createSurveyLink(surveyLink, interceptId, additionalEmbeddedData);
								}
							: () => {},
					};
				} catch (e) {
					throw new Error(`error getting intercept: ${e}`);
				}
			} else {
				throw new Error('error getting intercept: Performance cookies must be enabled');
			}
		} else {
			//Queue if API is still loading OR if GDPR hasn't loaded yet since we don't know if we're allowed to run
			let queuedPromise = new Promise((resolve, reject) => {
				//Only wait around for 10 seconds
				const timeoutID = setTimeout(() => reject('error getting intercept: Timed out'), 10000);
				let queuedFunction = async () => {
					clearTimeout(timeoutID);
					resolve(await hasInterceptPassed(interceptId, shouldUnload));
				};
				interceptPassedCalls.push(queuedFunction);
			});
			return queuedPromise;
		}
	};

	const checkAndStartSessionRecording = async function () {
		if (qualtricsApiLoaded && GDPRLoaded) {
			if (performanceCookiesAllowed) {
				try {
					var OABCcookieName = 'OptanonAlertBoxClosed';
					var OABCcookie = getOABCookie(OABCcookieName);
					if (OABCcookie) {
						window.QSI.API.load();
						await window.QSI.API.SessionRecording.start();
					}
				} catch (e) {
					console.warn(`Error on Start of Session Recording: ${e}`);
				}
			} else {
				console.warn('Error on Start of Session Recording: Performance cookies must be enabled');
				// Call to delete cookie, just in case it is there.
				document.cookie = `${config.srcookie}=; Max-Age=-99999999;`;
			}
		} else {
			//Queue if API is still loading OR if GDPR hasn't loaded yet since we don't know if we're allowed to run
			let queuedPromise = new Promise((resolve, reject) => {
				//Only wait around for 10 seconds
				const timeoutID = setTimeout(
					() => reject('Error on Start of Session Recording: Timed out'),
					10000
				);
				let queuedFunction = async () => {
					clearTimeout(timeoutID);
					resolve(await checkAndStartSessionRecording());
				};
				sessionRecordingStartCalls.push(queuedFunction);
			});
			return queuedPromise;
		}
	};

	window.FS = window.FS || {};
	window.FS.Qualtrics = {
		hasInterceptPassed,
		checkAndStartSessionRecording,
	};

	//handle GDPR
	window.FS.GDPR.getSavedConsent(groups => {
		performanceCookiesAllowed = groups['performance'];
		GDPRLoaded = true;
		//If there's still something to run in the queue (api loaded before GDPR)
		if (qualtricsApiLoaded && !ranQueue) {
			runQueuedFunctions();
		}
	});
	//setup listener for change in consent
	window.FS.GDPR.onConsentChange(groups => {
		performanceCookiesAllowed = groups['performance'];
		if (qualtricsApiLoaded && GDPRLoaded) {
			if (performanceCookiesAllowed) {
				window.QSI.API.load().then(() => {
					window.QSI?.API?.SessionRecording?.start().catch(e =>
						console.warn(`Error on Start of Session Recording: ${e}`)
					);
				});
			} else {
				window.QSI?.API?.SessionRecording?.stop()
					.catch(e => console.warn(`Error on Stop of Session Recording: ${e}`))
					.finally(() => {
						// Delete the cookie along with the stop of the recording.
						document.cookie = `${config.srcookie}=; Max-Age=-99999999;`;
					});
			}
		}
	});
	checkAndStartSessionRecording();
})('{{{config}}}');
